import React from "react";
import { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { ScrollToTop } from "../components";
import { connect } from "react-redux";
import DefaultLayout from "../layout/default";
import BlankLayout from "../layout/fullpage";
import Loading from "../components/Loader/Loading";

// Auth pages
import AuthLogin1 from "../pages/auths/AuthLogin1";
import ProfileModal from "../pages/Users/ProfileModal.jsx";
import PermissionDenied from "../pages/error/PermissionDenied";
import NotFound from "../pages/error/NotFound";
import ServiceType from "../pages/ServiceType/index.js";
import ServiceCenter from "../pages/ServiceCenter/index.js";
import Users from "../pages/Users/index.js";
import Vehicle from "../pages/Vehicle/index.js";
import BillingAdd from "../pages/Billing/BillingAdd.js";
import Billing from "../pages/Billing/index.js";
import ServiceCenterDetails from "../pages/ServiceCenter/ServiceCenterDetails.js";
import VehicleBrandModel from "../pages/Vehicle/VehicleBrandModel/index.js";
import ServiceCenterBillHistory from "../pages/ServiceCenter/ServiceCenterBillHistory.js";
import ServiceCenterUsers from "../pages/ServiceCenter/ServiceCenterUsers.js";
import Expense from "../pages/Expense/index.js";
import DashboardPage from "../pages/Dashboard";
import CashFlow from "../pages/Cashflow/index.js";
import ExpenseCategorySubCategory from "../pages/Expense/CategoryAndSubcategory/index.js";
import Vendor from "../pages/Vendor/index.js";
import MobileLayout from "../layout/MobileLayout.js/index.js";
import Employee from "../pages/Employee/index.js";
import Inventory from "../pages/Inventory/index.js";
import { useIsMobile } from "../utilities/index.js";
import Report from "../pages/report/index.js";
import Attendance from "../pages/Attendance/index.jsx";
import SalaryDashboard from "../pages/salary/index.js";
import BillingEdit from "../pages/Billing/BillingEdit.js";
import EmployeeSalary from "../pages/Employee/EmployeeDetails/EmployeeSalary.js";
import EmployeeDetails from "../pages/Employee/EmployeeDetails/index.js";
import EmployeeAttendanceCalendar from "../pages/Employee/EmployeeDetails/EmployeeAttendance.js";
import DoorStepEmployee from "../pages/DoorStepEmployee/index.js";
import DoorStepEmployeeSalary from "../pages/DoorStepEmployee/DoorStepSalary/index.js";
import DoorStepEmployeeAttedance from "../pages/DoorStepEmployee/DoorStepAttendance/index.js";
import DoorStepEmployeeDetails from "../pages/DoorStepEmployee/DoorStepEmployeeDetails/index.js";
import DoorStepEmployeeSalaryDetails from "../pages/DoorStepEmployee/DoorStepEmployeeDetails/DoorStepEmployeeSalaryDetails.js";
import DoorStepSalaryCalculation from "../pages/DoorStepEmployee/DoorStepSalary/DoorStepSalaryCalculation.js";
import DoorStepEmployeeUtility from "../pages/DoorStepEmployee/DoorStepEmployeeUtility/index.js";
import DoorStepEmployeeAttendanceDetails from "../pages/DoorStepEmployee/DoorStepEmployeeDetails/DoorStepEmployeeAttendanceDetails.js";

const FlashScreen = () => {
  return (
    <BlankLayout title="Loading..." mask="2" centered>
      <Loading />
    </BlankLayout>
  );
};

export const allRoutes = [
  {
    url: "/",
    element: <AuthLogin1 />,
    isProtected: false,
    routeTitle: "Accounting Made Easy for Car Wash Owners",
    accessRole: [],
  },

  {
    url: "/dashboard",
    element: <DashboardPage />,
    isProtected: true,
    routeTitle: "dashboard",
    accessRole: ["admin", "user"],
  },

  //service-center

  {
    url: "/service-center",
    element: <ServiceCenter />,
    isProtected: true,
    routeTitle: "service-center",
    accessRole: ["admin"],
  },
  {
    url: "/service-center/:id",
    element: <ServiceCenterDetails />,
    isProtected: true,
    routeTitle: "service-center-details",
    accessRole: ["admin"],
    children: [
      {
        url: "",
        element: <ServiceCenterBillHistory />,
        routeTitle: "service-center-bills",
      },
      {
        url: "users",
        element: <ServiceCenterUsers />,
        routeTitle: "service-center-users",
      },
    ],
  },

  //service-type
  {
    url: "/service-type",
    element: <ServiceType />,
    isProtected: true,
    routeTitle: "service-type",
    accessRole: ["admin", "user"],
  },

  //user

  {
    url: "/user",
    element: <Users />,
    isProtected: true,
    routeTitle: "user",
    accessRole: ["admin"],
  },

  //vehicle

  {
    url: "/vehicle",
    element: <Vehicle />,
    isProtected: true,
    routeTitle: "vehicle",
    accessRole: ["admin", "user"],
  },
  {
    url: "/vehicle-brand-model",
    element: <VehicleBrandModel />,
    isProtected: true,
    routeTitle: "vehicle-brand-model",
    accessRole: ["admin", "user"],
  },

  //bill

  {
    url: "/bill",
    element: <Billing />,
    isProtected: true,
    routeTitle: "bill",
    accessRole: ["admin", "user"],
  },

  {
    url: "/bill-add",
    element: <BillingAdd />,
    isProtected: true,
    routeTitle: "bill-add",
    accessRole: ["user"],
  },

  {
    url: "/bill-edit/:id",
    element:<BillingEdit/>,
    isProtected: true,
    routeTitle: "bill-add",
    accessRole: ["user"],
  },

  //expense
  {
    url: "/expense",
    element: <Expense />,
    isProtected: true,
    routeTitle: "expense",
    accessRole: ["admin", "user"],
  },
  {
    url: "/expense-category",
    element: <ExpenseCategorySubCategory />,
    isProtected: true,
    routeTitle: "expense-category",
    accessRole: ["admin", "user"],
  },

  //cashflow
  {
    url: "/cashflow",
    element: <CashFlow />,
    isProtected: true,
    routeTitle: "cashFlow",
    accessRole: ["admin", "user"],
  },

  //vendor
  {
    url: "/vendor",
    element: <Vendor />,
    isProtected: true,
    routeTitle: "vendor",
    accessRole: ["admin", "user"],
  },

  //employee
   {
    url: "/employee",
    element:<Employee/>,
    isProtected: true,
    routeTitle: "employee",
    accessRole: ["admin", "user"],
  },
  {
    url: "/employee/:id",
    element:<EmployeeDetails/>,
    isProtected: true,
    routeTitle: "employee-details",
    accessRole: ["admin", "user"],
    children: [
      {
        url: "",
        element:<EmployeeAttendanceCalendar/>,
        routeTitle: "Employee-attendance",
      },
      {
        url: "salary",
        element:<EmployeeSalary/>,
        routeTitle: "Employee-salary",
      },
    ],
  },

   {
    url: "/door-step-employee",
    element:<DoorStepEmployee/>,
    isProtected: true,
    routeTitle: "door-step-employee",
    accessRole: ["admin", "user"],
  },
     {
    url: "/door-step-attendance",
    element:<DoorStepEmployeeAttedance/>,
    isProtected: true,
    routeTitle: "door-step-employee-attendance",
    accessRole: ["admin", "user"],
  },
     {
    url: "/door-step-salary",
    element:<DoorStepEmployeeSalary/>,
    isProtected: true,
    routeTitle: "door-step-employee-salary",
    accessRole: ["admin", "user"],
  },
  {
    url: "/door-step-salary-calculate",
    element:<DoorStepSalaryCalculation/>,
    isProtected: true,
    routeTitle: "door-step-employee-accounting",
    accessRole: [ "user"],
  },
   {
    url: "/door-step-utility",
    element:<DoorStepEmployeeUtility/>,
    isProtected: true,
    routeTitle: "door-step-utility",
    accessRole: [ "user","admin"],
  },

  {
    url: "/door-step-employee/:id",
    element:<DoorStepEmployeeDetails/>,
    isProtected: true,
    routeTitle: "door-step-employee-details",
    accessRole: ["admin", "user"],
    children: [
      {
        url: "",
        element:<DoorStepEmployeeAttendanceDetails/>,
        routeTitle: "door-step-employee-accountin",
      },
      {
        url: "salary",
        element:<DoorStepEmployeeSalaryDetails/>,
        routeTitle: "door-step-employee-salary",
      },
    ],
  },

  //inventory
   {
    url: "/inventory/:tab",
    element:<Inventory/>,
    isProtected: true,
    routeTitle: "inventory",
    accessRole: ["admin", "user"],
  },
  {
    url:"/profile",
    element:<ProfileModal/>,
    isProtected: true,
    routeTitle: "profile",
    accessRole: ["admin", "user"],
  },

   {
    url:"/reports",
    element:<Report/>,
    isProtected: true,
    routeTitle: "reports",
    accessRole: ["admin"],
  },
    {
    url:"/attendance",
    element:<Attendance/>,
    isProtected: true,
    routeTitle: "attendance",
    accessRole: ["admin","user"],
  },
   {
    url:"/salary",
    element:<SalaryDashboard/>,
    isProtected: true,
    routeTitle: "salary",
    accessRole: ["admin"],
  }


];


function Router({ isAuthenticated, userRole, isCheckingAuth }) {
  const isMobile = useIsMobile();
  const handleProtectedRoute = (route) => {
    if (!isAuthenticated) {
      return <Navigate to="/" />;
    }
    if (!route.accessRole.includes(userRole)) {
      return <PermissionDenied />;
    }
    return route.element;
  };

  const handlePublicRoute = (route) => {
    if (isAuthenticated) {
      // Redirect authenticated users trying to access public routes
      return <Navigate to="/dashboard" />;
    }
    return route.element;
  };

  const renderRoutes = (routes, isChildElement = false) =>
    routes.map((item) => {
      let element;

      if (isChildElement) {
        element = item.element;
      } else {
        // Top-level route with layout
        element = item.isProtected ? (
          isMobile ? (
            <MobileLayout title={item.routeTitle}>
              {handleProtectedRoute(item)}
            </MobileLayout>
          ) : (
            <DefaultLayout title={item.routeTitle}>
              {handleProtectedRoute(item)}
            </DefaultLayout>
          )
        ) : (
          <BlankLayout title={item.routeTitle} centered>
            {handlePublicRoute(item)}
          </BlankLayout>
        );
      }

      return (
        <Route key={item.url} path={item.url} element={element}>
          {item.children &&
            renderRoutes(
              item.children.map((child) => ({
                ...child,
                isProtected: item.isProtected,
                accessRole: item.accessRole,
              })),
              true // pass Child Element flag
            )}
        </Route>
      );
    });

  return isCheckingAuth ? (
    <FlashScreen />
  ) : (
    <ScrollToTop>
      <Routes>
        {renderRoutes(allRoutes)}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ScrollToTop>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.is_superuser ? "admin" : "user" || "",
  isAuthenticated: state.auth.user !== null,
  isCheckingAuth: state.auth.isCheckingAuth,
});

export default connect(mapStateToProps)(Router);
